var exports = {
  "Lw": "UploadDropModal.module__overlay___dkh6X0",
  "r3": "UploadDropModal.module__dialog___dkh6X0",
  "ew": "UploadDropModal.module__dialogIconCircle___dkh6X0",
  "aY": "UploadDropModal.module__dialogIcon___dkh6X0",
  "tp": "UploadDropModal.module__dialogTextBlock___dkh6X0",
  "nl": "UploadDropModal.module__dialogTitle___dkh6X0",
  "HP": "UploadDropModal.module__dialogDescription___dkh6X0",
  "ly": "UploadDropModal.module__statusBanner___dkh6X0",
  "zm": "UploadDropModal.module__statusBannerActive___dkh6X0",
  "Sl": "UploadDropModal.module__statusBannerDefault___dkh6X0",
  "UX": "UploadDropModal.module__statusIndicator___dkh6X0",
  "Ie": "UploadDropModal.module__statusIndicatorActive___dkh6X0",
  "I8": "UploadDropModal.module__statusIcon___dkh6X0",
};

module.exports = exports;
